import { getColor } from 'common/constants/_colors';
import styled from 'styled-components';

export const StyledFilterItem = styled.div`
  color: ${getColor('shuttleGray')};
  font-size: 1.3rem;
  white-space: nowrap;

  &:not(:last-child) {
    border-right: 1px solid ${getColor('silverSand')};
    padding-right: 1rem;
    margin-right: 1rem;
  }
`;

export const StyledFilters = styled.div`
  display: flex;
  align-items: center;
  line-height: 2.5rem;
`;
